import { useEffect, useState } from 'react';
import { TH } from '../lib/constants.js';
import { respondToFollowRequest, respondToInvite, fetchMySharedBooks, markNotificationsRead, fetchNotifications } from '../lib/api.js';
import { Av, Back } from '../components/Basic.jsx';
import { pushToast } from '../lib/helpers.js';
import { t as tr } from '../lib/i18n.js';
function timeAgo(iso){
  const diff=(Date.now()-new Date(iso).getTime())/1000;
  if(diff<60) return tr("notif_time_now");
  if(diff<3600) return tr("notif_time_min",{n:Math.floor(diff/60)});
  if(diff<86400) return tr("notif_time_hour",{n:Math.floor(diff/3600)});
  return tr("notif_time_day",{n:Math.floor(diff/86400)});
}
export function NotificationsView({t,st,dispatch,go,userId}){
  const [busyId,setBusyId]=useState(null);
  useEffect(()=>{
    if(!userId) return;
    fetchNotifications(userId).then(items=>dispatch({type:"LOAD_NOTIFICATIONS",items}));
    markNotificationsRead(userId);
    dispatch({type:"MARK_NOTIFS_READ_LOCAL"});
  },[userId]);
  const handleRespond=async(notif,accept)=>{
    if(busyId) return;
    setBusyId(notif.id);
    let ok=false;
    if(notif.type==="shared_book_invite"){
      ok=await respondToInvite(notif.data&&notif.data.sharedBookId,userId,accept,notif.id);
      if(ok&&accept){
        // Il libro condiviso deve comparire subito nel tuo scaffale,
        // non solo al prossimo riavvio dell'app.
        const books=await fetchMySharedBooks(userId);
        dispatch({type:"LOAD_SHARED_BOOKS",items:books});
      }
    } else {
      ok=await respondToFollowRequest(userId,notif.fromUserId,accept,notif.id);
    }
    setBusyId(null);
    if(!ok){ pushToast(dispatch,tr("notif_action_failed")); return; }
    dispatch({type:"REMOVE_NOTIFICATION_LOCAL",id:notif.id});
  };
  const describe=(n)=>{
    if(n.type==="follow_request") return tr("notif_desc_follow_request");
    if(n.type==="follow_accepted") return tr("notif_desc_follow_accepted");
    if(n.type==="reaction") return n.data&&n.data.emoji?tr("notif_desc_reaction_with_emoji",{emoji:n.data.emoji}):tr("notif_desc_reaction_plain");
    if(n.type==="shared_book_invite") return <>{tr("notif_desc_shared_invite")} {n.data&&n.data.icon} <b>{n.data&&n.data.title}</b></>;
    if(n.type==="shared_book_deleted") return <>{tr("notif_desc_shared_deleted")} <b>{n.data&&n.data.title}</b></>;
    if(n.type==="goal_unlocked") return tr("goal_unlocked_toast",{name:(n.data&&n.data.name)||""});
    return "";
  };
  const isActionable=(n)=>n.type==="follow_request"||n.type==="shared_book_invite";
  // Le notifiche "di sistema" (oggi solo l'obiettivo sbloccato) non vengono
  // da un altro utente — niente "@nome utente" davanti al testo, niente
  // avatar cliccabile verso un profilo che non esiste.
  const isSystemNotif=(n)=>n.type==="goal_unlocked";
  return(
    <div className="screen fade" style={{background:t.bg,display:"flex",flexDirection:"column"}}>
      <div style={{padding:"14px 14px 11px",display:"flex",alignItems:"center",gap:11,borderBottom:`1px solid ${t.ac}18`,flexShrink:0}}>
        <Back fn={()=>go("feed")} t={t}/>
        <span style={{fontSize:17,fontWeight:800,color:t.tx,fontFamily:"Inter,sans-serif"}}>{tr("notif_header_title")}</span>
      </div>
      <div style={{flex:1,overflowY:"auto",padding:"6px 13px 20px"}}>
        {st.notifications.length===0?(
          <div style={{textAlign:"center",padding:"50px 20px"}}>
            <div style={{fontSize:36,marginBottom:12}}>🔔</div>
            <div style={{fontSize:14,fontWeight:700,color:t.tx,fontFamily:"Inter,sans-serif",marginBottom:7}}>{tr("notif_empty_title")}</div>
            <div style={{fontSize:12,color:t.soft,fontFamily:"Inter,sans-serif"}}>{tr("notif_empty_body")}</div>
          </div>
        ):st.notifications.map(n=>(
          <div key={n.id} style={{display:"flex",alignItems:"center",gap:11,padding:"11px 8px",borderRadius:13}}>
            {isSystemNotif(n)?(
              <div style={{width:44,height:44,borderRadius:"50%",background:t.pill,display:"flex",alignItems:"center",justifyContent:"center",fontSize:19,flexShrink:0}}>{(n.data&&n.data.emoji)||"🏆"}</div>
            ):(
              <div onClick={()=>go("profile_"+n.fromUsername)} style={{cursor:"pointer",flexShrink:0}}>
                <Av u={n.fromUsername} tid={n.fromTheme} sz={44} photo={n.fromAvatarUrl}/>
              </div>
            )}
            <div style={{flex:1,minWidth:0}}>
              <div style={{fontSize:13,color:t.tx,fontFamily:"Inter,sans-serif",lineHeight:1.4}}>
                {!isSystemNotif(n)&&<span onClick={()=>go("profile_"+n.fromUsername)} style={{fontWeight:700,cursor:"pointer"}}>@{n.fromUsername} </span>}
                {describe(n)}
              </div>
              <div style={{fontSize:10,color:t.soft,fontFamily:"Inter,sans-serif",marginTop:2}}>{timeAgo(n.createdAt)}</div>
            </div>
            {isActionable(n)&&(
              <div style={{display:"flex",gap:6,flexShrink:0}}>
                <div onClick={()=>handleRespond(n,true)} style={{padding:"7px 13px",borderRadius:20,background:t.pill,color:"#fff",fontSize:11.5,fontWeight:700,fontFamily:"Inter,sans-serif",cursor:"pointer",opacity:busyId===n.id?.6:1}}>{tr("notif_accept")}</div>
                <div onClick={()=>handleRespond(n,false)} style={{padding:"7px 13px",borderRadius:20,background:t.soft+"18",color:t.soft,fontSize:11.5,fontWeight:700,fontFamily:"Inter,sans-serif",cursor:"pointer",opacity:busyId===n.id?.6:1}}>{tr("notif_decline")}</div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
